import {
  DEFAULT_ABBREVIATION_LANGUAGE,
  DEFAULT_LANGUAGE,
} from '@/config/defaultConfig';
import Cookies from 'js-cookie';
// router
import RouterPath from '@/router/routingPath';
// utils
import { getLocalStorage } from '@/utils/global';
// type
import type { GameFirstUserInfoType, UserInfoIF } from '@/api/common/data.d';
import { StoreKeyEnum } from '@/definition/common/data.d';

// 本地语言
export const localLanguage: any =
  getLocalStorage(StoreKeyEnum.LOCAL_LANGUAGE) ||
  Cookies.get(StoreKeyEnum.LOCAL_LANGUAGE) ||
  DEFAULT_LANGUAGE;

// 语言简写
export const plugInLanguage: any =
  getLocalStorage(StoreKeyEnum.DESIGN_LANGUAGE) ||
  Cookies.get(StoreKeyEnum.DESIGN_LANGUAGE) ||
  DEFAULT_ABBREVIATION_LANGUAGE;

// 默认用户信息
export const defaultUserInfo: UserInfoIF = {
  id: 0,
  accountId: '',
  accountName: '',
  email: '',
  roleName: '',
  roleNameEn: '',
  roleCode: '',
  isNewUser: false,
  hasProject: false,
  isAcceptedInvitation: false,
  predictiveTagSwitch: false,
  isViewRegionGroup: true,
  inGame: false,
  timeZone: '',
  timeFormat: '',
};

// 默认被邀请项目申请信息
export const defaultProjectApplyInfo = {
  /** 邀请人 */
  inviter: '',
  /** 邀请码 */
  invitationCode: '',
  /** 邀请加入项目id */
  projectId: 0,
  /** 邀请加入项目名 */
  projectName: '',
  roleName: '',
  /** 邀请角色code码 */
  roleCode: '',
};

// 默认业务信息
export const defaultBusiness = {
  gameId: 0,
  gameName: '',
  iconUrl: '',
  bgUrl: '',
  isAuthorize: 0,
  roles: [],
};

// 当前项目下首个用户加入的时间 默认信息
export const defaultGameFirstUser: GameFirstUserInfoType = {
  gameId: 0,
  createdAt: '2023-01-01T00:00:00+00:00',
  timeZone: 'UTC+00:00',
  timeYMD: '2023-01-01',
  timeHMS: '00:00:00',
};

export const defaultFilter = {
  /** 页码 */
  pageIndex: 1,
  /** 页长 */
  pageSize: 10,
};

export const defaultFilterList = {
  /** 所有活动 */
  [RouterPath.ACTIVITY_MANAGE_LIST]: { ...defaultFilter },
  /** A/B 测试列表 */
  [RouterPath.ACTIVITY_AB_TEST_LIST]: { ...defaultFilter },
  /** 周期活动 */
  [RouterPath.ACTIVITY_CYCLE_LIST]: { ...defaultFilter },
  /** 自动化活动 */
  [RouterPath.ACTIVITY_AUTO_LIST]: { ...defaultFilter },
  /** 用户旅程 */
  [RouterPath.USER_JOURNEY_LIST]: { ...defaultFilter },
  /** 审批活动 */
  [RouterPath.ACTIVITY_APPROVAL_LIST]: { ...defaultFilter },
  /** 所有联系人 */
  [RouterPath.CONTACT_MANAGE_LIST]: { ...defaultFilter },
  /** 所有联系人 - 导入历史 */
  [RouterPath.CONTACT_MANAGE_IMPORT_HISTORY]: { ...defaultFilter },
  /** 所有联系人 - 删除历史 */
  [RouterPath.CONTACT_MANAGE_DELETE_HISTORY]: { ...defaultFilter },
  /** 导出中心 - 导出历史 */
  [RouterPath.EXPORT_CENTER_LIST]: { ...defaultFilter },
  /** 表单 */
  [RouterPath.SIGN_UP_FORM_LIST]: { ...defaultFilter },
  /** 分层规则 */
  [RouterPath.SEGMENTS_MANAGE_LIST]: { ...defaultFilter },
  /** 标签管理 */
  [RouterPath.LABEL_MANAGE_LIST]: { ...defaultFilter },
  /** 邮件模板 - 营销 */
  [RouterPath.MAIL_TEMPLATE_MARKETING_LIST]: { ...defaultFilter },
  /** 邮件模板 - 营销创建 */
  [RouterPath.MAIL_TEMPLATE_MARKETING_CREATE]: {
    ...defaultFilter,
    pageSize: 20,
  },
  /** 邮件模板 - 事务 */
  [RouterPath.MAIL_TEMPLATE_TRANSACTIONAL_LIST]: {
    ...defaultFilter,
  },
  /** 邮件模板 - 事务创建 */
  [RouterPath.MAIL_TEMPLATE_TRANSACTIONAL_CREATE]: {
    ...defaultFilter,
    pageSize: 20,
  },
  /** 占位符 */
  [RouterPath.PLACEHOLDER_MANAGE_LIST]: { ...defaultFilter },
  /** 我的项目 */
  [RouterPath.BUSINESS_MANAGE_MY_PROJECT_LIST]: { ...defaultFilter },
  /** 项目设置 - 发件人地址 */
  [RouterPath.SETTING_MANAGE_SENDER_ADDRESS_LIST]: {
    ...defaultFilter,
  },
  /** 项目设置 - 发件人名称 */
  [RouterPath.SETTING_MANAGE_SENDER_NAME_LIST]: {
    ...defaultFilter,
  },
  /** 项目设置 - 区域管理 */
  [RouterPath.SETTING_MANAGE_AREA_LIST]: { ...defaultFilter },
  /** 项目设置 - 拒绝列表 */
  [RouterPath.SETTING_MANAGE_REJECT_LIST]: {
    ...defaultFilter,
  },
  /** 项目设置 - API密钥 */
  [RouterPath.SETTING_MANAGE_API_KEY_LIST]: {
    ...defaultFilter,
  },
  /** 活动报表 */
  [`${RouterPath.ACTIVITY_REPORT_LIST}`]: {
    ...defaultFilter,
  },
  /** WhatsApp 活动列表 */
  [RouterPath.ACTIVITY_WHATSAPP_LIST]: {
    ...defaultFilter,
  },
  // /** 活动报表 - ALL */
  // [`${RouterPath.ACTIVITY_REPORT_LIST}/${ActivityReportTabEnum.ALL}`]: {
  //   ...defaultFilter,
  // },
  // /** 活动报表 - Group */
  // [`${RouterPath.ACTIVITY_REPORT_LIST}/${ActivityReportTabEnum.GROUP}`]: {
  //   ...defaultFilter,
  // },
};
